import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Appcues Case Study | Canny';
const Description =
  'Read about how Appcues closes the feedback loop with Canny to improve their product and customer experience.';
const Image = 'https://canny-assets.io/images/8f04d9b78a681a15822c2d2209dcb2a0.png';

export default class AppcuesLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/case-studies/appcues' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
